import { api } from "../api";
import {
  ActivityBloomLevel,
  ActivityEvidenceType,
  ActivityNature,
  ActivityPrimariaInteractionType,
} from "../../components/Forms/LessonForm/utils";

export interface SugerirPastillasInput {
  education_level: 'KINDER' | 'PRIMARIA';
  titulo: string;
  descripcion?: string;
  materiales?: string;
  duracion?: number;
}

export interface SugerirPastillasResponse {
  bloom_level: ActivityBloomLevel[];
  primaria_interaction_type: ActivityPrimariaInteractionType[];
  evidence_type: ActivityEvidenceType[];
  activity_nature: ActivityNature[];
}

export const sugerirPastillasIA = async (
  input: SugerirPastillasInput
): Promise<SugerirPastillasResponse> => {
  const response = await api.post<SugerirPastillasResponse>(
    '/ai/sugerir-pastillas',
    input
  );
  return response.data;
};

export interface GenerateActivitySummaryInput {
  title: string;
  activityType: string;
  instructions?: string;
  materials?: string;
}

export interface GenerateActivitySummaryResponse {
  summary: string | null;
}

export interface LessonActivityPayload {
  title: string;
  activityType: string;
  orderBy: number;
  instructions?: string;
  materials?: string;
  isGame?: boolean;
}

export interface GenerateLessonSummaryInput {
  lessonTitle: string;
  lessonGoal?: string;
  activities: LessonActivityPayload[];
}

export interface GenerateLessonSummaryResponse {
  lines: string[] | null;
}

export interface GenerateManipulativeMaterialsInput {
  materialsText?: string;
}

export interface GenerateManipulativeMaterialsResponse {
  materials: string | null;
}

/**
 * Genera un resumen de actividad usando IA
 */
export const generateActivitySummary = async (
  input: GenerateActivitySummaryInput,
): Promise<GenerateActivitySummaryResponse> => {
  const response = await api.post<GenerateActivitySummaryResponse>(
    "/ai/generate-activity-summary",
    input,
  );
  return response.data;
};

/**
 * Genera un resumen de lección usando IA
 */
export const generateLessonSummary = async (
  input: GenerateLessonSummaryInput,
): Promise<GenerateLessonSummaryResponse> => {
  const response = await api.post<GenerateLessonSummaryResponse>(
    "/ai/generate-lesson-summary",
    input,
  );
  return response.data;
};

/**
 * Genera lista de materiales manipulativos mediante IA
 */
export const generateManipulativeMaterials = async (
  input: GenerateManipulativeMaterialsInput,
): Promise<GenerateManipulativeMaterialsResponse> => {
  const response = await api.post<GenerateManipulativeMaterialsResponse>(
    "/ai/generate-manipulative-materials",
    input,
  );
  return response.data;
};
